import { useAlert } from "@apex/component-library";
import { ComponentType, useEffect } from "react";

import { usePermissions } from "../../contexts/permissions";
import { hasRequiredPermissions } from "./helpers/hasRequiredPermissions";

export const withPermissions =
  <T extends object>(
    WrappedComponent: ComponentType<T>,
    requiredPermissionKeys: string[]
  ) =>
  (props: T) => {
    const { permissions, isSuccess } = usePermissions();
    const { setAlert } = useAlert();

    const hasPermission = hasRequiredPermissions(
      permissions,
      requiredPermissionKeys
    );

    useEffect(() => {
      if (!hasPermission) {
        setTimeout(() =>
          setAlert({
            variant: "error",
            description: "Additional permissions are required.",
            title: "Unauthorized",
            isClosable: true,
          })
        );
      }
    }, [isSuccess, hasPermission, setAlert]);

    if (hasPermission) {
      return <WrappedComponent {...props} />;
    }

    return null;
  };
